import {call, put} from 'redux-saga/effects';
import {receiveHolidayHoursData} from "../actions/facilitiesActions";
import {fetchHolidayHoursData} from "../api/fetchFacilitiesData";

export default function* getHolidayHours(action) {
  try {
    const facilityData = yield call(fetchHolidayHoursData, action.payload);
    yield put(receiveHolidayHoursData(facilityData));
  } catch (e) {
    console.log(e)
  }
}


// WEBPACK FOOTER //
// ./src/sagas/holidayHoursSaga.js